<template>
  <div v-loading.fullscreen.lock="true"></div>
</template>

<script>
// 数据字典
import { purchaseAllTypeDict } from '@/dictionary/project/common'
import { portalFeaturesRouter } from '@/dictionary/portal-router'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'BlankPage',

  data() {
    return {}
  },

  computed: {
    ...mapState('company', [
      'isCertified',
      'isPurchaser',
      'isAgency',
      'isSupplier'
    ]),
    ...mapState('user', ['roles']),
    ...mapState('router', ['currentWorkbench'])
  },

  async mounted() {
    // 门户跳转到业务平台，查看或操作交易页面（基本为供应商身份）
    if (this.$route.query.type == 1) {
      const { purchaseType, orderId, tradeId } = this.$route.query

      purchaseAllTypeDict.array.forEach(obj => {
        if (obj.value === Number(purchaseType)) {
          const params = { orderId }
          tradeId && (params.tradeId = tradeId)
          this.$router.replace({
            name: obj.tradeRouterName,
            params
          })
        }
      })

      // 门户快捷键跳转业务平台
    } else if (this.$route.query.type == 2) {
      const { features } = this.$route.query
      portalFeaturesRouter.array.forEach(obj => {
        if (obj.value === features) {
          this.$router.replace({ name: obj.router })
        }
      })

      // 国资门户采购公告跳转到公告详情页面
    } else if (this.$route.query.type == 3) {
      const { purchaseType, orderId } = this.$route.query

      purchaseAllTypeDict.array.forEach(obj => {
        if (obj.value === Number(purchaseType)) {
          this.$router.replace({
            name: obj.detailRouterName,
            params: { orderId }
          })
        }
      })
    } else if (this.$route.query.type == 4) {
      // 第三方跳转云采购平台，根据目标页路由名称与路由传参进行页面跳转
      const { targetRouterName, pageParams, pageQuery } = this.$route.query
      this.$router.replace({
        name: targetRouterName,
        params: pageParams ? JSON.parse(pageParams) : {},
        query: pageQuery ? JSON.parse(pageQuery) : {}
      })
    } else {
      this.resetUser().then(res => {
        this.$router.replace({ name: 'Homepage' })
      })
    }
  },

  methods: {
    ...mapActions('user', ['resetUser']),

    goNotRight() {
      if (!this.Identity) {
        this.$router.replace({
          name: 'NotRight'
        })
      }
    }
  }
}
</script>
